module.exports = __webpack_public_path__ + "media/images/icon__calendar@3x-ce29926bffeb18f8df93bb1ae0999dd0.png";